import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["turboFrame"]

  preview() {
    const formData = new FormData(this.element)
    const url = new URL(this.turboFrameTarget.dataset.url)
    url.search = new URLSearchParams(formData).toString()
    url.searchParams.append("preview", 1)
    this.turboFrameTarget.setAttribute("src", url.toString())
  }
}
